import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('tab-content', {
  template: require('./template.html'),
  computed: {
    ...mapGetters([
      'currentPage',
      'globalDragEl',
      'dragging',
    ]),
    watchDroplets() {
      const drps = this.tab.droplets;
      let cls = '';
      if (drps.length < 1) {
        cls = 'drzDroplet-puddleDropped';
      }
      return cls;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    draggingTemplateDrp() {
      return this.globalDragEl === 'templateDroplet';
    },
  },
  name: 'tab-content',
  props: [
    'tab',
    'droplet',
    'display',
    'index',
  ],
  watch: {
    'tab.droplets': function watchDroplets() {
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.$emit('on-drop', this.index);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/tabs/components/tab-content/index.js